<template>
  <div>
    <div class="header">
      <div class="header_info">
        <div class="header_one">
          岳泰兴智慧导诊一体机

        </div>
        <div class="header_one">岳泰兴智慧导诊机器人</div>
        <div class="header_two">
          <div class="header_two_info">
            新形势
          </div>
          <div class="header_two_info">
            多功能
          </div>
          <div class="header_two_info">
            易维护
          </div>
          <div class="header_two_info">
            个性化服务
          </div>
        </div>
        <div class="header_three">
          岳泰兴智慧导诊一体机（智慧导诊导航一体机）集智能分诊、科室信息查询、院内导航、健康宣教于一体，聚焦“优化就医流程”核心需求，通过人工智能物联网技术，连接患者与医院服务，解决“挂号难、找科室难、信息查询难”等痛点。
        </div>
        <div class="header_four" @click="select">
          立即咨询
        </div>
      </div>
    </div>
    <div class="lightModuleOuterContent">
      <div class="lightModuleOuterContent_text">
       <img src="/intelligentGuidance/17.png">
        <div class="wenzi">产品功能</div>
        <img src="/intelligentGuidance/18.png">
      </div>
      <div class="lightModuleOuterContent_title">
        重新定义导诊体验的四大核心优势
      </div>
      <div class="formTabButtonList">
        <div :class="toTextIndex === index ?'formTabButtonInfo blue':'formTabButtonInfo'" v-for="(item,index) in textList" :key="index" @mouseover="toText(index)" @click="toText(index)">
          <div class="item_left"></div>
          <div class="item">{{item}}</div>
          <div class="item_right"></div>
        </div>
      </div>
      <div class="textListInfo_list" >
        <div class="text_list_left">
          <div class="text_list_text"> {{textListInfo[toTextIndex].text}}</div>
          <div class="text_list_title"> {{textListInfo[toTextIndex].title}}</div>
          <div class="text_list_three" @click="select">了解详情<img src="/intelligentGuidance/19.png"></div>
        </div>
        <div class="image_right" v-if="!textListInfo[toTextIndex].img2">
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img"
              :preview-src-list="[textListInfo[toTextIndex].img]">
          </el-image>
        </div>
        <div class="image_right2" v-if="textListInfo[toTextIndex].img2">
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img"
              >
          </el-image>
          <el-image
              class="imgInfo" :src="textListInfo[toTextIndex].img2"
              >
          </el-image>
        </div>
      </div>
    </div>


    <div class="three">
     <div class="three_info">
       <div class="three_left">
         <div class="three_left_name">
           产品优势及其特色
         </div>
         <div class="three_left_title">
           聚焦“优化就医流程”核心需求，通过人工智能、物联网技术，连接患者与医院服务，解决“挂号难、找科室难、信息查询难”等痛点
         </div>
       </div>
       <div class="three_right">
         <div class="three_right_info">
           <img src="/intelligentGuidance/8.png">
           <div class="three_text">精准</div>
           <div class="three_title">根据患者症状，智慧导诊机智能推荐科室，避免盲目挂号，减少挂错号情况。</div>
         </div>
         <div class="three_right_info">
           <img style="width: 180px;height: 170px;margin-bottom: 10px" src="/intelligentGuidance/5.png">
           <div class="three_text">多元化</div>
           <div class="three_title">集导诊、科室医生查询、院内导航、健康宣教等功能于一体，一台设备满足患者就医多样化需求。</div>
         </div>
         <div class="three_right_info">
           <img style="width: 180px;height: 170px;margin-bottom: -10px" src="/intelligentGuidance/9.png">
           <div class="three_text">高效</div>
           <div class="three_title">智能导诊设备支持触屏和语音交互，患者可轻松自助服务。24小时在线，随时解答疑问</div>
         </div>
         <div class="three_right_info">
           <img src="/intelligentGuidance/11.png">
           <div class="three_text">多模拟交互</div>
           <div class="three_title">支持语音、文字、触控等多种交互方式，适应不同年龄、需求的患者,操作更便捷。</div>
         </div>
         <div class="three_right_info">
           <img style="width: 180px;height: 170px;margin-bottom: -10px" src="/intelligentGuidance/7.png">
           <div class="three_text">精准个性化</div>
           <div class="three_title">根据患者病情、历史就诊记录等:提供个性化导诊方案，提升就医体验。</div>
         </div>
         <div class="three_right_info">
           <img src="/intelligentGuidance/12.png">
           <div class="three_text">高效赋能</div>
           <div class="three_title">减少导诊人员工作量，提升导诊效率，降低医疗机构运营成本。</div>
         </div>
       </div>
     </div>
    </div>

    <div class="four">
      <div class="lightModuleOuterContent_text">
        <img src="/intelligentGuidance/17.png">
        <div class="wenzi">场景应用</div>
        <img src="/intelligentGuidance/18.png">
      </div>
      <div class="lightModuleOuterContent_title">
        高效智能，轻松掌推
      </div>
      <div class="four_image">

        <img style="width: 600px" src="/intelligentGuidance/15.png">
        <img style="width: 350px" src="/intelligentGuidance/16.png">
      </div>
    </div>

    <div class="five">
      <div class="five_title">产品介绍</div>
      <div class="five_sub">智慧导诊系统 · 智慧导诊一体机 · 挂号缴费一体机 · 医院自助机</div>
      <div class="five_p">
        岳泰兴智慧导诊系统是面向医院门诊大厅、住院部等场景的一站式自助服务解决方案。系统以智慧导诊一体机（智慧导诊导航一体机）为核心终端，融合人工智能与物联网技术，帮助医院优化就医流程、缓解门诊窗口压力，让患者从进门到就诊全程有引导、少跑腿。
      </div>
      <div class="five_p">
        围绕门诊自助服务场景，公司形成了完整的产品矩阵：智慧导诊一体机、挂号缴费一体机、医院自助机（医院自助服务终端）承担智能分诊、科室信息查询、院内导航与健康宣教；支持患者自助挂号、缴费与信息查询；可灵活部署于门诊大厅、候诊区与住院部，减轻人工窗口排队压力。作为湖南本地的智慧导诊厂家，岳泰兴医疗同时提供医院自助机与医院自助服务终端等自助设备，可根据医院场地条件、科室设置与业务流程提供适配方案。
      </div>
      <div class="five_p">
        院内导航系统是智慧导诊一体机的核心能力之一，通过科室平面图与路径规划帮助患者快速定位目标科室；智能导诊系统则围绕就诊动线设计，让科室推荐、挂号缴费与路线指引形成闭环，真正服务于医院的日常就诊流程。
      </div>
      <div class="five_faq">
        <div class="faq_item">
          <div class="faq_q">智慧导诊一体机是什么？</div>
          <div class="faq_a">智慧导诊一体机是部署在医院门诊大厅等区域的自助服务终端，集智能分诊、科室信息查询、院内导航、健康宣教、挂号缴费、报告查询打印于一体。患者通过触屏或语音即可完成科室推荐与路线查询，减少盲目排队与往返。</div>
        </div>
        <div class="faq_item">
          <div class="faq_q">智慧导诊系统能帮医院解决哪些问题？</div>
          <div class="faq_a">主要面向“挂号难、找科室难、信息查询难”三类门诊痛点：通过症状自诊与科室推荐减少挂错号，通过院内导航帮助患者快速找到科室，通过自助查询减少人工咨询量，同时降低导诊人员工作量与医院运营成本。</div>
        </div>
        <div class="faq_item">
          <div class="faq_q">挂号缴费一体机可以用在哪里？</div>
          <div class="faq_a">挂号缴费一体机（医院自助机）通常部署在门诊大厅，供患者自助完成挂号、缴费与信息查询；部署更灵活，可用于门诊大厅、候诊区、住院部等区域，分担人工窗口压力。</div>
        </div>
        <div class="faq_item">
          <div class="faq_q">如何咨询智慧导诊一体机的采购与方案？</div>
          <div class="faq_a">岳泰兴医疗是湖南本地的智慧导诊系统与医疗自助终端厂家，提供产品方案咨询与售后技术支持，可通过官网“联系我们”页面或全国厂家热线 400-022-9558 咨询。</div>
        </div>
      </div>
    </div>
    <tail_menu></tail_menu>
    <div ref="brandConcept"></div>
  </div>
</template>

<script>
import tail_menu from "@/components/tail_menu_phone";
export default {
  name: "intelligentGuidance",
  components:{
    tail_menu
  },
  data(){
    return{
      toTextIndex:0,
      textListInfo:[
        {
          text:'智能导诊',
          title:'根据患者症状匹配挂号科室，提供挂号科室荐，展示科室和专家信息，患者选择科室后可直接扫码挂号，减少医患资源错配。',
          img:'/intelligentGuidance/14.png',
          img2:'/intelligentGuidance/13.png',
        },
        {
          text:'科室信息查询',
          title:'提供便捷直观的科室信\n' +
              '息查询，包括科室基本信息、特色优势、就诊指南、医生团队介绍等帮助患者了解科室，提升就医效率和满意度助力医院品牌建设。',
          img:'/intelligentGuidance/3.png',
        },
        {
          text:'院内导航服务',
          title:'通过科室院内导航平面图，帮助患者快速定位目标科室位置，展示科室布局和周边环境，方便患者按图索骥，高效抵达就诊地点。',
          img:'/intelligentGuidance/6.png',
        },
        {
          text:'健康宣教服务',
          title:'向患者及家属普及医学知识和健康信息，引导理性就医，减少不必要就诊和检查，提升公众健康素养，促进健康生活方式形成，补充医患\n' +
              '沟通内容。',
          img:'/intelligentGuidance/2.png',
        },
      ],
      textList:[
        '智能导诊',
        '科室信息查询',
        '院内导航服务',
        '健康宣教服务'
      ]
    }
  },
  mounted(){
    this.injectFaqSchema()
  },
  methods:{
    select(){
      this.$refs.brandConcept.scrollIntoView({ behavior: 'smooth' });
    },
    toText(index){
      this.toTextIndex = index
    },
    // 注入 FAQPage 结构化数据：内容直接取自页面上的问答，避免维护两份文案
    injectFaqSchema(){
      if (typeof document === 'undefined' || document.getElementById('faq-schema')) return
      const items = [].slice.call(document.querySelectorAll('.faq_item')).map((el) => {
        const q = el.querySelector('.faq_q')
        const a = el.querySelector('.faq_a')
        if (!q || !a) return null
        return {
          '@type': 'Question',
          name: q.textContent.trim(),
          acceptedAnswer: { '@type': 'Answer', text: a.textContent.trim() },
        }
      }).filter(Boolean)
      if (!items.length) return
      const el = document.createElement('script')
      el.type = 'application/ld+json'
      el.id = 'faq-schema'
      el.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: items,
      })
      document.head.appendChild(el)
    },
  }
}
</script>

<style scoped lang="scss">
  .header{
    width: 100%;
    height: 800px;
    background-image: url('/intelligentGuidance/1.jpg');
    //background-size: 100% 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    position: relative;
    .header_info{
      position: absolute;
      left: 100px;
      top: 90px;
      .header_one{
        font-size: 70px;
        color: white;
      }
      .header_two{
        display: flex;
        align-items: center;
        margin-top: 30px;
        color: white;
        .header_two_info{
          border-radius: 50px;
          background-color: rgba(255,255,255,0.4);
          margin-right: 20px;
          font-size: 34px;
          padding: 10px 24px;
        }
      }
      .header_three{
        max-width: 900px;
        margin-top: 30px;
        color: white;
        font-size: 44px;
      }
      .header_four{
        color: rgba(67,131,241,1);
        font-size: 38px;
        background: white;
        width: max-content;
        margin-top: 30px;
        border-radius: 100px;
        padding: 10px 48px;
        cursor: pointer;
      }
    }
  }

  .lightModuleOuterContent{
    background-image: url('/intelligentGuidance/4.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    border-bottom: 1px solid rgba(237, 237, 237, 1);
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 60px 60px 0 60px;
    .lightModuleOuterContent_text{
      display: flex;
      align-items: center;

      img{
        width: 200px;
      }
      .wenzi{
        font-size: 78px;
        font-weight: bold;
        color: rgb(51, 51, 51);
        margin-left: 40px;
        margin-right: 40px;
      }
    }
    .lightModuleOuterContent_title{
      color: rgba(16,16,16,1);
      font-size: 46px;
      margin-top: 20px;
    }
    .formTabButtonList{

      display: flex;
      justify-content: space-around;
      .formTabButtonInfo:nth-of-type(1){
        .item_left{
          width: 0;
          height: 0;
          border-radius: 20px 0 0 20px;
          background: rgba(9,90,249,1);
        }
        .item{
          padding-right: 20px;
        }
      }
      .formTabButtonInfo:nth-of-type(4){
        .item_right{
          width: 0;
          height: 0;
          border-radius: 0 20px 20px 0;
          background: rgba(9,90,249,1);
        }
        .item{
          padding-left: 20px;
        }
      }
      .formTabButtonInfo{
        display: flex;
        align-items: flex-end;
        margin-top: 30px;
        .item_left{
          width: 0;
          height: 0;
          border-bottom: 87px solid transparent; /* 上边框设置为透明 */
          border-right: 34px solid rgba(9,90,249,1); /* 左边框设置为黑色，形成三角形 */
        }
        .item_right{
          width: 0;
          height: 0;
          border-top: 87px solid transparent; /* 上边框设置为透明 */
          border-left: 22px solid rgba(9,90,249,1); /* 左边框设置为黑色，形成三角形 */
        }
        .item{
          font-family: 微软雅黑;
          color: white;
          font-size: 46px;
          font-weight: bold;
          //font-weight: normal;
          padding: 10px;
          cursor: pointer;
          background-color: rgba(9,90,249,1);
        }
      }
      .blue:nth-of-type(1){
        .item_left{
          width: 0;
          height: 0;
          border-radius: 20px 0 0 20px;
          background: rgba(255,198,3,1);
        }
        .item{
          padding-right: 20px;
        }
      }
      .blue:nth-of-type(4){
        .item_right{
          width: 0;
          height: 0;
          border-radius: 0 20px 20px 0;
          background: rgba(254,170,4,1);
        }
        .item{
          padding-left: 20px;
        }
      }
      .blue{
        .item{
          background: linear-gradient(84.24deg, rgba(255,198,3,1) 4.1%,rgba(254,170,4,1) 95.13%);
          color: rgba(0,0,0,1);
        }
        .item_left{
          border-right: 34px solid rgba(255,198,3,1); /* 左边框设置为黑色，形成三角形 */
        }
        .item_right{
          border-left: 50px solid rgba(254,170,4,1); /* 左边框设置为黑色，形成三角形 */
        }
      }
    }
    .textListInfo_list{
      height: 1000px;
      width: 94%;
      position: relative;
      .text_list_left{
        margin-top: 30px;
        .text_list_text{
          font-size: 80px;
          color: rgb(51, 51, 51);
          margin-bottom: 30px;
          font-weight: bold;
        }
        .text_list_title{
          width: 1400px;
          font-size: 66px;
          line-height: 86px;
          display: inline-block;
          color: rgb(153, 153, 153);
        }
        .text_list_three{
          background-color: rgba(9,90,249,1);
          width: max-content;
          display: flex;
          align-items: center;
          margin-top: 50px;
          color: white;
          padding: 20px 60px;
          font-size: 44px;
          cursor: pointer;
          img{
            width: 70px;
            margin-left: 10px;
          }
        }
      }
      .image_right{
        //animation: ceshi 2s forwards;
        position: absolute;
        top: 450px;
        left: 700px;
        .imgInfo{

          width: 550px;
          height: 500px;
        }
      }
      .image_right2{
        position: absolute;
        top: 380px;
        left: 700px;
        //animation: ceshi 2s forwards;
        display: flex;
        .imgInfo{
          width: 320px;
          height: 554px;
        }
      }
    }
  }

  .three{
    background-image: url('/intelligentGuidance/10.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    justify-content: center;
    .three_info{
      margin-top: 80px;
      width: 94%;
      .three_left{
        color: white;

        .three_left_name{
          font-size: 64px;

        }
        .three_left_title{
          font-size: 50px;
          margin-top: 20px;
        }
      }
      .three_right{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: space-around;
        margin-bottom: 50px;
        .three_right_info{
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 20px;
          margin-top: 50px;
          background-color: rgba(14,84,237,1);
          color: white;
          width: 43%;
          height: 440px;
          img{
            width: 180px;
            height: 170px;
          }
          .three_text{
            margin-top: 14px;
            font-size: 40px;
          }
          .three_title{
            margin-top: 18px;
            max-width: 600px;
            font-size: 40px;
          }
        }
      }
    }

  }


  .four {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 60px 60px 30px 60px;
    .lightModuleOuterContent_text {
      display: flex;
      align-items: center;

      img {
        width: 200px;
      }

      .wenzi {
        font-size: 78px;
        font-weight: bold;
        color: rgb(51, 51, 51);
        margin-left: 40px;
        margin-right: 40px;
      }
    }
    .lightModuleOuterContent_title{
      color: rgba(16,16,16,1);
      font-size: 46px;
      margin-top: 20px;
    }
    .four_image{
      width: 1200px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
    }
  }

  /* 产品介绍 + 常见问题：文字模块，同时承担 SEO 正文内容
     字号与页面既有正文（three_title 44px / lightModuleOuterContent_title 46px）保持同级 */
  .five{
    padding: 60px 60px 50px 60px;
    background-color: rgba(247,249,252,1);
    .five_title{
      font-size: 78px;
      font-weight: bold;
      color: rgb(51,51,51);
      text-align: center;
    }
    .five_sub{
      font-size: 34px;
      color: rgb(153,153,153);
      text-align: center;
      margin-top: 20px;
      margin-bottom: 60px;
    }
    .five_p{
      font-size: 44px;
      line-height: 78px;
      color: rgb(102,102,102);
      margin-bottom: 30px;
      text-indent: 2em;
    }
    .faq_item{
      margin-bottom: 40px;
      .faq_q{
        font-size: 46px;
        font-weight: bold;
        color: rgb(51,51,51);
        margin-bottom: 14px;
        &::before{
          content: 'Q ';
          color: rgba(9,90,249,1);
        }
      }
      .faq_a{
        font-size: 44px;
        line-height: 78px;
        color: rgb(102,102,102);
      }
    }
  }
</style>
